import React, { FC } from 'react';
import { P } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { redirectTo } from 'omni-package-react-core';
import { StyledButton, StyledDivBlock, StyledDivContainer, StyledDivButton, StyledSection } from './Content.styles';
import { PersonalInformation } from '../../../interfaces/PersonalInformation';
import Constants from '../../../Constants';

export interface ContentProps { personalInfo: PersonalInformation }

const Content: FC<ContentProps> = ({ personalInfo }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('ConsentTile');

  return (
    <StyledDivContainer data-testid="consentContainer">
      <StyledDivBlock>
        {personalInfo?.consent?.consents.map((x, i) => (
          <StyledSection key={i} name={x?.description}>
            <P>{x?.value === true ? t('accepted') : t('refuse')}</P>
          </StyledSection>
        ))}
      </StyledDivBlock>
      <StyledDivButton>
        <StyledButton outline onClick={() => redirectTo(`${Constants.ConsentFormPagePath}`, navigate)}>{t('modifyButtonLabel')}</StyledButton>
      </StyledDivButton>
    </StyledDivContainer>
  );
};
export default Content;
